/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_UntitledInputs */

const cs_blog_untitled = /** @type {(inputs: Blog_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez názvu`)
};

const en_blog_untitled = /** @type {(inputs: Blog_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled article`)
};

/**
* | output |
* | --- |
* | "Untitled article" |
*
* @param {Blog_UntitledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_untitled = /** @type {((inputs?: Blog_UntitledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_UntitledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_untitled(inputs)
	return cs_blog_untitled(inputs)
});